"use client";

import React, { createContext, useContext, useState } from "react";

export const SideBarAuthContext = createContext({
  openedModal: "login",
  setOpenedModal: (value: "register" | "login") => {},
});

export const SideBarAuthModalProvider = ({ children }) => {
  const [openedModal, setOpenedModal] = useState<"register" | "login">(null);

  const values = {
    openedModal,
    setOpenedModal,
  };

  return (
    <SideBarAuthContext.Provider value={values}>
      {children}
    </SideBarAuthContext.Provider>
  );
};
